export default function getCaptchaToken(): Promise<string> {
  const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
  if (!siteKey) {
    return Promise.reject(new Error('Missing reCAPTCHA site key'));
  }

  return new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(siteKey, { action: 'submit' }).then(resolve).catch(reject);
    });
  });
}
